module.exports = __webpack_public_path__ + "img/footer.6e351a45.png";